import { transition, trigger, useAnimation } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { pulse } from '@freelancer/animations';
import {
  UnreadIndicatorColor,
  UnreadIndicatorPosition,
  UnreadIndicatorSize,
} from './unread-indicator.types';

@Component({
  standalone: true,
  selector: 'fl-unread-indicator',
  template: `
    <div
      class="UnreadIndicator"
      [attr.aria-label]="label"
      [attr.data-border]="border"
      [attr.data-counter]="counter"
      [attr.data-position]="position"
      [attr.data-size]="size"
      [attr.data-color]="color"
      [@pulseAnimation]="counter"
    >
      @if (counter) {
        <span
          class="UnreadIndicator-counter"
          [attr.aria-hidden]="label !== undefined ? true : false"
        >
          @if (counter !== 'placeholder') {
            @if (counter <= countLimit) {
              {{ counter }}
            }
            @if (counter > countLimit) {
              {{ countLimit }}+
            }
          }
        </span>
      }
    </div>
  `,
  styleUrls: ['./unread-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('pulseAnimation', [
      transition(':enter, :increment, :decrement', [useAnimation(pulse)]),
    ]),
  ],
})
export class UnreadIndicatorComponent {
  countLimit = 99;

  /** Set aria label for accessibility */
  @Input() label: string;

  /**
   * Accepts 'placeholder' to display the indicator
   * the same size as the counter
   * */
  @HostBinding('attr.data-counter')
  @Input()
  counter: number | 'placeholder';

  /**
   * Specifies the desired position of the unread indicator
   */
  @HostBinding('attr.data-position')
  @Input()
  position: UnreadIndicatorPosition = UnreadIndicatorPosition.TOP_RIGHT;

  @HostBinding('attr.data-size')
  @Input()
  size = UnreadIndicatorSize.MID;

  @Input()
  @HostBinding('attr.data-border')
  border = false;

  @Input()
  color = UnreadIndicatorColor.RED;
}
